/**
 * Proof of Address Required Component
 * Based on Figma: https://www.figma.com/design/8nBzg5I71TF3EWyr6NcpVa/Fiat?node-id=4021-78651
 */
import { FileText } from 'lucide-react';

import { Button } from '@components/ui/button';

interface ProofOfAddressRequiredProps {
  /**
   * Callback when "Maybe later" button is clicked
   */
  onMaybeLater: () => void;
  /**
   * Callback when "Resubmit now" button is clicked
   */
  onResubmitNow: () => void;
}

export function ProofOfAddressRequired({
  onMaybeLater,
  onResubmitNow,
}: ProofOfAddressRequiredProps) {
  return (
    <div className="sm:w-[394px]">
      {/* Content Section */}
      <div className="flex flex-col gap-8">
        {/* Warning Icon */}
        <div className="border-warning/16 bg-warning/16 flex size-16 items-center justify-center rounded-full border p-2">
          <div className="bg-warning/16 flex size-full items-center justify-center rounded-full">
            <FileText className="text-warning size-8" />
          </div>
        </div>

        {/* Text Content */}
        <div className="flex flex-col gap-1.5">
          <h2 className="text-foreground">Proof of address required</h2>
          <p className="text-muted-foreground text-body-paragraph1">
            We were unable to verify your home address based on the details
            provided. Please upload a valid proof of address to complete the
            verification.
          </p>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="mt-6 flex gap-4">
        <Button
          type="button"
          variant="secondary"
          onClick={onMaybeLater}
          className="flex-1"
        >
          Maybe later
        </Button>
        <Button
          type="button"
          variant="primary"
          onClick={onResubmitNow}
          className="flex-1"
        >
          Resubmit now
        </Button>
      </div>
    </div>
  );
}
